import _ from 'lodash'
import type {Experiment, RunningExperiments} from '@wix/document-services-types'

const isTb = process.env.VIEWER_NAME === 'tb'
const runningExperiments: RunningExperiments = {
    dm_stretchRichText: 'true',
    dm_failSplitQueries: 'new',
    dm_throwOnSoqFailure: 'new',
    dm_failCsaveInitConflict: 'new',
    dm_useWhitelistRemovalForCsave: 'new',
    dm_repeatersFromViewer: 'old', //should turn on when we are ready to open in prod
    dm_disableValidationWhitelist: 'new',
    dm_enableMLSlug: 'true',
    dm_nsTypesFailInvalidDesign: 'old', //will turn on by default once we resolve all currently failing tests
    dm_repeaterDontAddRepeatedRefCompData: 'new',
    dm_mobileAlgoValidationNoConduct: 'true',
    dm_throwForRemoteCompsEditorFeatures: 'true',
    dm_cleanupAtomicScopesGarbage: 'true',
    dm_useResourceLoaderForInit: 'true',
    dm_fixTextLinksAfterRefAddToContainer: 'new',
    'specs.UseTBAsMainRScript': isTb ? 'new' : 'old',
    'specs.UseTbInPreview': isTb ? 'new' : 'old',
    dm_fixerVersioningDataCollection: 'new',
    dm_failDalStrictSchemaValidation: 'true',
    dm_noWhitelistDalStrictSchemaValidation: 'false', // will be turned on only after cleanup of whitelist
    dm_missingSkinValidator: 'true',
    dm_forceConfigName: 'true',
    dm_blocksNewDevCenterApiComponents: 'true',
    dm_reportRemoteStructureSet: 'true',
    dm_deleteRemoveByParent: 'true',
    dm_resolveVariantRelationComponentByRelationships: 'true',
    dm_validateStylableStyles: 'true',
    dm_validateMigratedStylableStyles: 'true',
    dm_useViewerIsShowOnFixedPosition: 'true',
    dm_internalRefGarbageCollector: 'true',
    dm_sendPresetInfoInBlocksBuild: 'true',
    dm_failOnExceedsMaxActionsPerTransaction: 'true',
    dm_recalculateBlocksOnGroupingAndUngrouping: 'true',
    dm_fixTextScaleInMobileAlgo: 'true',
    dm_platformWorkerFedopsLoggerDefaultsOverride: 'true',
    dm_returnAllAppDataInAddApps: 'true',
    dm_oldHoverBoxDeprecationFixer: 'true',
    dm_rejectDalOnBuildingPayloadForCsaveError: 'true',
    dm_fixSystemStyleAsRefArray: 'true',
    dm_publishPipelineRcSite: 'true',
    dm_allowAddingStripForNonFullWidthPopup: 'true',
    dm_moveMaxChildrenNumberMetadataToExt: 'true',
    dm_moveCompValidationToExt: 'true',
    dm_builderDataInAppDescriptor: 'false', //will turn on only for builder
    dm_shouldValidateComponentLayoutMobileAlgo: 'true',
    dm_moveComponentLayoutToExt: 'new',
    dm_waitForPendingCsaveIfNothingToSaveOnSaveAndWait: 'new',
    dm_moveBehaviorsDeserializerToExt: 'new',
    dm_reportReferencedDataNodesGC: 'true',
    dm_useExtensionUpdateDisplayedOnlyComponentsDefs: 'new',
    dm_moveCollectAncestorsVariablesIdsToExt: 'new',
    dm_moveVariantUtilsToExt: 'new',
    dm_createWidgetSeparator: 'true',
    dm_runAndWaitForApprovalOnSaveDisabled: 'true',
    dm_react18: 'true',
    dm_moveValidationBaseline: 'true',
    dm_doNotCreateGetterForClassnames: 'true',
    dm_variantRefOwner: 'true',
    dm_variantRefOwnerFixer: 'true',
    dm_loadRemoteWidgetMetadataFromExt: 'true',
    dm_cloudSiteExtensionMigrationDev: 'new',
    dm_failOnMissingLayoutQuery: 'true',
    dm_observables: 'true',
    dm_enforceStrictValidationEverywhere: 'true',
    dm_enforceNoWhitelistDalStrictSchemaValidation: 'true',
    dm_useReferencedStrictSchemas: 'true',
    dm_removeDesktopOnlyChildrenFromHiddenPanel: 'true',
    dm_alwaysRemoveExistingMobileStructure: 'true',
    dm_measurementsV2: 'true',
    dm_useNewGetVariableReferences: 'true',
    dm_proceedWithBranchIdFromSiteInfo: 'true',
    dm_systemContainerValidation: 'true',
    dm_newModelCompatibilityValidation: 'true',
    dm_sapiCacheSchemaCollectionPerApp: 'new',
    dm_fixAlignmentForStretchedContainers: 'true',
    dm_tpaLegacyTypeOnComponentsAdd: 'true',
    dm_uploadSync: 'true',
    dm_wixCodeModelPopulateOnBaseline: 'true',
    dm_refactorStaticSlotToDynamic: 'true',
    dm_mergeComponentsToStore: 'new',
    dm_logErrorIfDuplicateHoverVariantIsAdded: 'true',
    dm_moveCompRemovalToExt: 'true',
    dm_useExtensionHasCompsConnectedToMenu: 'true',
    dm_failOnCorruptSingleLayoutData: 'true',
    dm_skipSaveOnAlreadyRegisteredNotifier: 'true',
    dm_approveCSMDataOnSsave: 'true'
}

export const getDefaultExperiments = () => _.cloneDeep(runningExperiments)

export const isExperimentOn = (value: string) => !!(value && value !== 'old' && value !== 'false')

export const createTestExperimentInstance = (experimentOverrides?: RunningExperiments): Experiment => {
    const experiments = _.merge({}, runningExperiments, experimentOverrides)
    return {
        getRunningExperiments: () => experiments,
        getValue: (name: string) => experiments[name],
        isOpen: (name: string) => {
            const value = experiments[name]
            return isExperimentOn(value)
            // return !!(value && value !== 'old' && value !== 'false')
        },
        isMultiValueExperimentOpen: (name: string) => !!experiments[name]
    }
}
